module.exports = __webpack_public_path__ + "j.no2.f5f23141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/j.no2.jpg
// module id = R5eB
// module chunks = 0